// components/GlobalLoader.js
import React from "react";
import { useSelector } from "react-redux";
import styled, { keyframes } from "styled-components";

// Full-screen overlay loader
const FullScreenOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(184, 235, 239, 0.6); // Dim background
  z-index: 15000; // Ensure it's on top
  display: flex;
  justify-content: center;
  align-items: center;
`;

// Loader animation
const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

// Loader spinner
const LoaderSpinner = styled.div`
  border: 6px solid rgba(0, 101, 192, 0.3);
  border-top: 6px solid white;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: ${rotate} 1s linear infinite;
`;

// Loader container for areas like content with sidebar and topbar
const ContentLoaderContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 101, 192, 0.5); // Semi-transparent background
  z-index: 1000; // Ensure it's on top of content
  display: flex;
  justify-content: center;
  align-items: center;
`;

const GlobalLoader = ({ fullscreen = true }) => {
  const loadingCount = useSelector((state) => state.loading.loadingCount);

  if (loadingCount === 0) {
    return null;
  }

  if (fullscreen) {
    return (
      <FullScreenOverlay>
        <LoaderSpinner />
      </FullScreenOverlay>
    );
  } else {
    return (
      <ContentLoaderContainer>
        <LoaderSpinner />
      </ContentLoaderContainer>
    );
  }
};

export default GlobalLoader;
